import { render, staticRenderFns } from "./estatistica.vue?vue&type=template&id=40a17a5b&"
import script from "./estatistica.vue?vue&type=script&lang=js&"
export * from "./estatistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports